import { IBaseAction } from "../Actions/BaseAction";
import { INotification } from "../Models/Notification";
import { IUpdateNotificationRequest } from "../Models/Requests/Notifications/UpdateNotificationRequest";

export type GetNotificationsInitiate = IBaseAction<[Date, Date]>;
export type GetNotificationsSuccess = IBaseAction<INotification[]>;
export type GetNotificationsFailure = IBaseAction<string>;
export type SetLoadingNotificationsAction = IBaseAction<boolean>;
export type UpdateNotificationsInitiate = IBaseAction<INotification[]>;
export type UpdateNotificationsSuccess = IBaseAction<INotification[]>;
export type UpdateNotificationsFailure = IBaseAction<string>;
export type SetNotificationsDrawerVisible = IBaseAction<boolean>;
export type SetNotificationFilterDates = IBaseAction<[Date, Date]>;
/** all */
export type UpdateAllNotificationsReadStatusInitiate = IBaseAction<boolean>;
export type UpdateAllNotificationsReadStatusSuccess = IBaseAction<boolean>;
export type UpdateAllNotificationsReadStatusFailure = IBaseAction<string>;
export type UpdateAllNotificationsActiveStatusInitiate = IBaseAction<boolean>;
export type UpdateAllNotificationsActiveStatusSuccess = IBaseAction<boolean>;
export type UpdateAllNotificationsActiveStatusFailure = IBaseAction<string>;
/** single */
export type UpdateNotificationInitiate = IBaseAction<IUpdateNotificationRequest>;
export type UpdateNotificationSuccess= IBaseAction<INotification>;
export type UpdateNotificationFailure = IBaseAction<string>;
/** a user clicks on a notification */
export type SetNotificationsByLinkIdViewedInitiate = IBaseAction<string>;
export type SetNotificationsByLinkIdViewedSuccess = IBaseAction<string>;
export type SetNotificationsByLinkIdViewedFailure = IBaseAction<string>;

export type NotificationActionType =
    GetNotificationsInitiate |
    GetNotificationsSuccess |
    GetNotificationsFailure |
    SetLoadingNotificationsAction |
    UpdateNotificationsInitiate |
    UpdateNotificationsSuccess |
    UpdateNotificationsFailure |
    SetNotificationsDrawerVisible |
    UpdateAllNotificationsReadStatusInitiate |
    UpdateAllNotificationsReadStatusSuccess |
    UpdateAllNotificationsReadStatusFailure |
    UpdateAllNotificationsActiveStatusInitiate |
    UpdateAllNotificationsActiveStatusSuccess |
    UpdateAllNotificationsActiveStatusFailure |
    UpdateNotificationInitiate |
    UpdateNotificationSuccess |
    UpdateNotificationFailure |
    SetNotificationFilterDates |
    SetNotificationsByLinkIdViewedInitiate |
    SetNotificationsByLinkIdViewedSuccess |
    SetNotificationsByLinkIdViewedFailure
;

export const GET_NOTIFICATIONS_INITIATE = "GET_NOTIFICATIONS_INITIATE";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";
export const SET_LOADING_NOTIFICATIONS = "SET_LOADING_NOTIFICATIONS";
export const SET_NOTIFICATION_FILTER_DATES = "SET_NOTIFICATION_FILTER_DATES";
/** all */
export const UPDATE_ALL_NOTIFICATIONS_READ_STATUS_INITIATE = "UPDATE_ALL_NOTIFICATIONS_READ_STATUS_INITIATE";
export const UPDATE_ALL_NOTIFICATIONS_READ_STATUS_SUCCESS = "UPDATE_ALL_NOTIFICATIONS_READ_STATUS_SUCCESS";
export const UPDATE_ALL_NOTIFICATIONS_READ_STATUS_FAILURE = "UPDATE_ALL_NOTIFICATIONS_READ_STATUS_FAILURE";
export const UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_INITIATE = "UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_INITIATE";
export const UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_SUCCESS = "UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_SUCCESS";
export const UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_FAILURE = "UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_FAILURE";
/** single */
export const UPDATE_NOTIFICATION_INITIATE = "UPDATE_NOTIFICATION_INITIATE";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAILURE = "UPDATE_NOTIFICATION_FAILURE";
export const SET_NOTIFICATIONS_DRAWER_VISIBLE = "SET_NOTIFICATIONS_DRAWER_VISIBLE";
/** a user clicks on a notification */
export const SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_INITIATE = "SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_INITIATE";
export const SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_SUCCESS = "SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_SUCCESS";
export const SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_FAILURE = "SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_FAILURE";